import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import styles from '../../../../TerminateEmployeeAccess.module.scss';
import { getBadgesByUser } from '../../../../_api';
import { useEffect, useState } from 'react';
import { DataTable } from '../../../../../../../../../components/UI/MDC/DataTable/DataTable';
import Spinner from '../../../../../../../../../components/UI/Spinner/Spinner';
const ReviewBadges = ({ staffMember, index, formik }) => {
	const [isLoading, setIsLoading] = useState(false);
	useEffect(() => {
		setIsLoading(true);
		if (
			staffMember?.fiId &&
			(!staffMember.badges || staffMember.badges.length === 0)
		) {
			getBadgesByUser(staffMember.fiId).then(response => {
				let formikStaffMember =
					formik.values.staffMembersForReview[index];
				formikStaffMember.badges = response.data.payload;
				//update formik state with user applications
				let updatedFormikStaffMembers = [
					...formik.values.staffMembersForReview,
				];
				updatedFormikStaffMembers.splice(index, 1, formikStaffMember);
				formik.setFieldValue('staffMembersForReview', [
					...updatedFormikStaffMembers,
				]);
				setIsLoading(false);
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const BadgesTable = {
		headers: [
			{
				Value: 'Number',
				props: { sort: null, onSortChange: null },
			},
			{
				Value: 'Type',
				props: { sort: null, onSortChange: null },
			},
		],
		rows: staffMember?.badges?.map((badge, index) => {
			return {
				Cells: {
					Number: {
						Value: badge.number,
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					Type: {
						Value: badge.type,
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},

					Key: badge.number?.toString(),
				},
			};
		}),
	};

	return (
		<>
			<div className={styles.margin_top_small}>
				<Accordion className={styles.accordion}>
					<AccordionSummary
						className={styles.accordion_summary_secondary}
						expandIcon={
							<ArrowDownwardIcon
								className={styles.accordion_summary_secondary}
							/>
						}
						aria-controls={'StaffMember-content-' + index}
						id={'StaffMember-header-' + index}
					>
						<Typography>Badges</Typography>
					</AccordionSummary>
					<AccordionDetails className={styles.accordion_details}>
						{isLoading ? (
							<Spinner />
						) : (
							<>
								{staffMember?.badges &&
								staffMember.badges.length > 0 ? (
									<DataTable
										rows={BadgesTable.rows}
										headers={BadgesTable.headers}
									/>
								) : (
									<p>no badges found for this user</p>
								)}
							</>
						)}
					</AccordionDetails>
				</Accordion>
			</div>
		</>
	);
};

export default ReviewBadges;
